module.exports = __webpack_public_path__ + "img/chess-knight.3eb9b492.svg";